import Address from '../AddressBuilder'

const _path = {
  sys_dept: Address.sys('sys/dept'),
  dept: Address.sys('sys/dept'),
}

export default {

  page(_parameter) { // 查询部门分页
    return sHttp.postJson(_path.sys_dept + 'page', _parameter)
  },

  list(_parameter) { // 查询部门列表
    return sHttp.postJson(_path.sys_dept + 'list', _parameter)
  },

  detail(id) { // 查询部门详细
    const _parameter = {id: id}
    return sHttp.postJson(_path.sys_dept + 'detail', _parameter)
  },

  updateBjzbz(id, bjzbz) { // 更新坐标
    const _parameter = {id: id, bjzbz: bjzbz}
    return sHttp.postJson(_path.sys_dept + 'updateBjzbz', _parameter)
  },

  tree(_parameter) { // 查询部门树结构
    return sHttp.postJson(_path.sys_dept + 'tree', _parameter)
  },

  treeSelect(parentId) { // 查询部门下拉树结构
    let _parameter = {}
    if (parentId) _parameter = {parentId: parentId}
    return sHttp.postJson(_path.sys_dept + 'treeSelect', _parameter)
  },

  getDeptByCode(code) {// 通过行政区划编码（和系统部门管理中的部门编码一样）来获取机构信息
    const _parameter = {code: code}
    return sHttp.postJson(_path.sys_dept + 'getDeptByCode', _parameter)
  },

  treeByRolMenu(roleId) { // 根据角色ID查询部门下拉树结构
    const _parameter = {
      roleId: roleId
    }
    return sHttp.postJson(_path.sys_dept + 'treeByRolMenu', _parameter)
  },

  deptListExclude(id) { // 查询部门列表（排除节点）
    const _parameter = {
      id: id
    }
    return sHttp.postJson(_path.sys_dept + 'list/exclude/', _parameter)
  },

  add(_parameter) { // 新增部门
    return sHttp.postJson(_path.sys_dept + 'add', _parameter)
  },

  update(_parameter) { // 修改部门
    return sHttp.postJson(_path.sys_dept + 'update', _parameter)
  },

  delete(id) { // 删除部门
    const data = {id: id}
    return sHttp.postJson(_path.sys_dept + 'delete', _parameter)
  },

  streetList(_parameter) { // 街道
    return sHttp.postJson(_path.sys_dept + 'jdList', _parameter)
  },

  yqcsList(_parameter) { // 园区初审部门
    return sHttp.postJson(_path.sys_dept + 'kcjCsList', _parameter)
  },

  taskDept(_parameter) { // 分配部门
    return sHttp.postJson(_path.dept + 'treeSelectPd', _parameter)
  },

  deptTreeList(_parameter) { // 街道 下部门
    return sHttp.postJson(_path.dept + 'getTaskDeptList', _parameter)
  },

}
